import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Clock, Plus, RefreshCw, UserX } from 'lucide-react';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Company dashboard card: scheduled workers who are 30+ min past shift start
// with no punch today. Each row deep-links to Payroll Review for backfill.
export const MissedClockInsCard = ({ token }) => {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  const navigate = useNavigate();

  const load = async () => {
    try {
      const r = await axios.get(`${API}/alerts/missed-clock-ins`, { headers: { Authorization: `Bearer ${token}` } });
      setData(r.data); setErr(false);
    } catch { setErr(true); }
  };
  useEffect(() => { load(); const t = setInterval(load, 5 * 60 * 1000); return () => clearInterval(t); }, [token]);

  if (!data && !err) return null;
  if (data && !data.enabled) return null;
  const rows = data?.rows || [];

  return (
    <div className="ht-card p-4" data-testid="missed-clockins-card">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-2">
          <UserX className={`w-4 h-4 ${rows.length ? 'text-amber-400' : 'text-emerald-400'}`} />
          <h3 className="text-sm font-semibold text-white">Missed clock-ins today</h3>
          <span className={`text-[11px] px-1.5 py-0.5 rounded-full ${rows.length ? 'bg-amber-500/15 text-amber-300' : 'bg-emerald-500/15 text-emerald-300'}`} data-testid="missed-clockins-count">
            {rows.length}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[11px] text-slate-500 hidden sm:inline">30 min grace · {data?.date}</span>
          <Button size="sm" variant="ghost" className="h-7 px-2" onClick={load} data-testid="missed-clockins-refresh"><RefreshCw className="w-3.5 h-3.5" /></Button>
        </div>
      </div>
      {err && <p className="text-xs text-amber-400 flex items-center gap-1" data-testid="missed-clockins-error"><AlertTriangle className="w-3.5 h-3.5" /> Couldn't load alerts.</p>}
      {!err && rows.length === 0 && (
        <p className="text-xs text-slate-400" data-testid="missed-clockins-empty">Everyone scheduled so far has clocked in.</p>
      )}
      {rows.length > 0 && (
        <ul className="divide-y divide-[#1F2D3F]">
          {rows.map((r) => (
            <li key={r.worker_id} className="py-2 flex items-center justify-between gap-3" data-testid={`missed-clockin-row-${r.worker_id}`}>
              <div className="min-w-0">
                <div className="text-sm text-white truncate">{r.worker_name}</div>
                <div className="text-[11px] text-slate-400 flex items-center gap-1 flex-wrap">
                  <Clock className="w-3 h-3" /> {r.shift_start}–{r.shift_end}
                  {r.team_name && <span>· {r.team_name}</span>}
                  <span className="text-amber-300">· {r.minutes_late >= 60 ? `${Math.floor(r.minutes_late / 60)}h ${r.minutes_late % 60}m` : `${r.minutes_late}m`} late</span>
                  {r.absence_reason && <span className="text-sky-300">· tagged {r.absence_reason}</span>}
                </div>
              </div>
              <Button size="sm" variant="outline" className="h-7 text-xs shrink-0"
                onClick={() => navigate(`/reports?report=payroll&worker=${r.worker_id}&q=${encodeURIComponent(r.worker_name)}&add=1`)}
                data-testid={`missed-clockin-add-${r.worker_id}`}>
                <Plus className="w-3 h-3 mr-1" /> Add hours
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
